
export class NotificationSettings{

  recipients: String;
  recipientsCC: string;
  frequency: NotificationSettings.Frequency;
  domain: string;
  lastNotification: string;

}
export namespace NotificationSettings{
  export enum Frequency{
    NONE,
    INSTANT,
    DAILY,
    WEEKLY,
    DAILY_WEEKLY,
    INSTANT_DAILY,
    INSTANT_WEEKLY,
    INSTANT_DAILY_WEEKLY
  }

}
